(function($) {
	$(document).ready(function() {

		var coverBlocks = $('.wp-block-cover');

		//
		if(!coverBlocks.length) {
			return;
		}

		var moveContentOut = function(coverblock) {
			if(coverblock.hasClass('moved-out')) {
				return;
			}

			var mobileDiv = coverblock.next('.mobile-cover-content');

			coverblock.find('.wp-block-cover__inner-container').children().each(function () {
				if($(this).is('h1')) {
					return;
				}
				$(mobileDiv).append(this);
			});

			coverblock.addClass('moved-out');
		};

		var moveContentIn = function(coverblock) {
			if(!coverblock.hasClass('moved-out')) {
				return;
			}

			var mobileDiv = coverblock.next('.mobile-cover-content');

			$(mobileDiv).children().each(function() {
				coverblock.find('.wp-block-cover__inner-container').append(this);
			});

			coverblock.removeClass('moved-out');
		};

		coverBlocks.each(function() {
			var h1 = $(this).find('h1');

			if(!h1.length) {
				return;
			}

			var coverblock = $(this);
			coverblock.after('<div class="mobile-cover-content"></div>');

			if($(window).width() < 1000) {
				moveContentOut(coverblock);
			}

			$(window).on("resize", function() {
				if($(window).width() < 1000) {
					moveContentOut(coverblock);
				} else {
					moveContentIn(coverblock);
				}
			})

		});

	})
})(window.jQuery);
